<template>
  <div class="AddProjectOrder">
    <div class="tabWrap">
      <div class="approve-rule">
        <span @click="SeeApproveRule">查看立项审批制度</span>
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="基本信息" name="first" class="firstTab">
          <div class="screenPanel">
            <el-form
              ref="ruleForm"
              :model="dialogForm"
              label-width="150px"
              :inline="true"
              :rules="rules"
            >
              <el-row>
                <el-col :span="12">
                  <el-form-item label="所属合同" prop="generalContractId">
                    <el-select
                      v-model="dialogForm.generalContractId"
                      placeholder="-请选择-"
                      @change="getContractName"
                      filterable
                    >
                      <el-option
                        :label="item.name"
                        :value="item.id"
                        v-for="(item, index) in ContractnameList"
                        :key="index"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="项目类型" prop="projectTypeKey">
                    <el-select
                      @change="projecttypechange"
                      v-model="dialogForm.projectTypeKey"
                      default-first-option
                      placeholder="请选择"
                      filterable
                    >
                      <el-option
                        :label="item.value"
                        :value="item.label"
                        v-for="(item, index) in projectTypeList"
                        :key="index"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="项目编号" prop="serialNumber">
                    <el-input
                      v-model="dialogForm.serialNumber"
                      placeholder="编码格式：QDLQ-GS-P1-20210101-A0001"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="项目名称" prop="name">
                    <el-input v-model="dialogForm.name"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="项目地址">
                    <ProjectAddress
                      @getAddressDetail="getAddressDetail"
                      :province="addressObj.province"
                      :city="addressObj.city"
                      :area="addressObj.area"
                      :address="addressObj.address"
                    ></ProjectAddress>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="项目信息" prop="projectInfo">
                    <el-input
                      type="textarea"
                      :rows="4"
                      maxlength="5000"
                      show-word-limit
                      placeholder="请输入内容"
                      v-model="dialogForm.projectInfo"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="开工日期">
                    <el-date-picker
                      v-model="dialogForm.startDate"
                      type="date"
                      placeholder="请选择日期"
                      value-format="yyyy-MM-dd"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="预计完工日期" prop="expectFinishDate">
                    <el-date-picker
                      v-model="dialogForm.expectFinishDate"
                      type="date"
                      placeholder="请选择日期"
                      value-format="yyyy-MM-dd"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="预计交工验收日期"
                    prop="expectFinishCheckDate"
                  >
                    <el-date-picker
                      v-model="dialogForm.expectFinishCheckDate"
                      type="date"
                      placeholder="请选择日期"
                      value-format="yyyy-MM-dd"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="预计审计日期" prop="expectAuditDate">
                    <el-date-picker
                      v-model="dialogForm.expectAuditDate"
                      type="date"
                      placeholder="请选择日期"
                      value-format="yyyy-MM-dd"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="预计竣工验收日期"
                    prop="expectCompleteCheckDate"
                  >
                    <el-date-picker
                      v-model="dialogForm.expectCompleteCheckDate"
                      type="date"
                      placeholder="请选择日期"
                      value-format="yyyy-MM-dd"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="缺陷责任期日期"
                    prop="defectLiabilityDate"
                  >
                    <el-date-picker
                      v-model="dialogForm.defectLiabilityDate"
                      type="date"
                      placeholder="请选择日期"
                      value-format="yyyy-MM-dd"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                  <el-form-item label="申请人" prop="applyUserName">
                    <el-input
                      v-model="dialogForm.applyUserName"
                      readonly
                    ></el-input>
                    <!-- <el-input
                      v-model="dialogForm.applyUserName"
                     readonly
                      @focus="ShowApplyUserDia"
                    ></el-input> -->
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="申请部门">
                    <!-- <el-input size="medium" v-model="dialogForm.applyDeptName" :editable="false"></el-input> -->
                    <el-input
                      v-model="dialogForm.applyDeptName"
                      readonly
                    ></el-input>
                    <!-- <el-cascader
                      ref="cascaderAddr"
                      v-model="dialogForm.applyDeptId"
                      :options="subDeptList"
                      :props="defaultProps"
                      @change="handleChange"
                      :placeholder="dialogForm.applyDeptName"
                      @active-item-change="handleChange"
                      change-on-select
                      @visible-change="handleDeptName"
                    ></el-cascader> -->
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="editFlag">
                <el-col :span="6">
                  <el-form-item label="单据状态:">{{
                    dialogForm.approveStatusName
                  }}</el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="流水号:">{{
                    dialogForm.flowNo
                  }}</el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item label="单据日期:">{{
                    dialogForm.createTime
                  }}</el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="附件"
          name="second"
          style="text-align: left"
          class="firstTab"
        >
          <upLoadFileDialog
            :itemVOs="dialogForm.projectItemsDtoList"
            @saveUpdateFile="saveUpdateFile"
            :addoredit="editFlag"
          ></upLoadFileDialog>
        </el-tab-pane>
        <el-tab-pane
          label="审批流程"
          name="third"
          style="text-align: left; width: 90%"
        >
          <ProjectApproveLine
            :addoredit="editFlag"
            :itemId="projectId"
            :approveType="approveType"
            :approveClass="approveClass"
            @saveApproveLine="saveApproveLine"
          ></ProjectApproveLine>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="bottomBtn">
      <el-button type="primary" @click="saveProjectInfo('ruleForm')"
        >提 交</el-button
      >
      <el-button type="info" @click="close">取 消</el-button>
    </div>

    <div v-if="false">{{ from.ownerName }}</div>
    <!-- 选择申请人弹窗弹框 -->
    <ApplyUserDialog
      @dialogClose="applyUserDiaVisible = false"
      @SaveApplyUser="saveApplyUser"
      @close="closeDialog"
      :applyUserName="dialogForm.applyUserName"
      :applyUserDiaVisible="applyUserDiaVisible"
    ></ApplyUserDialog>
  </div>
</template>

<script>
import {
  saveProjectInfoServices, //新增一条项目立项单信息
  updateProjectInfoServices, //更新一条项目立项单信息
  getContractCodeByUserCodeService, //获取下拉列表数据
  getBasicDataListService, //获取项目类型下拉列表
  getProjectDetailService, //获取一条项目信息
  getContractDetailService, //获取一条合同信息
} from "@/services/allContractServices";
import {
  getOrgIdService, //根据用户id获取组织id
  getsubDeptService, //获取项目部二级项目级联列表
  getDeptListService, //根据组织获取项目部一级数据下拉列表
} from "@/services/sysSettingService";
import { saveApproveFun } from "@/page/approveComponents/approve";
import ProjectApproveLine from "../../approveComponents/NewApproveLine"; //审批流程
import ApplyUserDialog from "../commonCell/ApplyUserDialog"; //选择申请人弹窗
import ProjectAddress from "./ProjectAddress"; //项目地址
import upLoadFileDialog from "@/components/upLoadFileDialog"; //上传附件

export default {
  name: "AddProjectOrder",
  components: {
    ProjectAddress, //项目地址
    ApplyUserDialog, //选择申请人组件
    ProjectApproveLine, //审批流程
    upLoadFileDialog, //上传附件
  },
  data() {
    return {
      activeName: "first", //活动tab页
      approveType: "project", //审批类型
      approveClass: "PROJECT",
      editFlag: false, //false：新建 true：编辑
      span: 24,
      belongContractList: [], //所属合同下拉列表
      projectTypeList: [], //项目类型下拉列表
      RouteParam: {}, //存储路由跳转参数
      category: "GENERAL_CONTRACT_NAME", //下拉列表类型，默认所属合同名称
      projectId: 0,
      subDeptList: [], //部门列表
      applyUserDiaVisible: false, //选择申请人弹窗
      ContractnameList: [],
      param: {}, //所属合同第一天数据
      dialogForm: {
        //基础信息form表单
        applyDeptId: 0, //申请人部门
        applyDeptName: "", //申请人部门名称
        applyUserId: 0, //申请人ID
        applyUserName: "", //申请人姓名
        approveStatus: "", //审批状态
        approveUserId: "", //当前审批人
        province: "", //省
        city: "", //城市
        area: "", //区
        address: "", //详细地址
        createTime: "", //城市
        expectAuditDate: "", //预计审计日期
        defectLiabilityDate: "", //缺陷责任期日期
        expectCompleteCheckDate: "", //预计竣工验收日期
        expectFinishCheckDate: "", //预计交工验收日期
        expectFinishDate: "", //预计完工日期
        generalContractAmount: "", //对应总包合同的金额
        generalContractId: "", //总包合同id
        generalContractName: "", //总包合同名称
        name: "", //项目名称
        profit: "", //项目利润
        projectInfo: "", //项目信息
        projectTypeKey: "", //项目类型编码
        projectTypeName: "", //项目类型名称
        serialNumber: "", //项目编号
        startDate: "", //开工日期
        projectItemsDtoList: [], //附件列表
      },
      approveParams: {
        approveProcessDtoList: [], //审批流列表
        approveStatusEnum: "UNDERAPPLY", //初始审批状态，目前只支持READY和UNDERAPPLY,可用值:READY,RECALL,UNDERAPLLY,PASS,REJECT,SHOW_SAVE,SHOW_CREATE,SHOW_SUBMIT
        itemId: 0, //审批对象ID
        itemName: "", //审批对象描述
        projectId: 0, //项目ID
      },
      addressObj: {
        //projectAddress 组件初始化数据
        province: "", //省
        city: "", //城市
        area: "", //区
        address: "", //详细地址
      },
      defaultProps: {
        label: "name",
        value: "id",
        lazy: true,
        lazyLoad(node, resolve) {
          const param = {};
          if (undefined != node.value) {
            param.deptId = node.value;
            getsubDeptService(param).then((res) => {
              if (res.code == 10000000) {
                const nodes = res.data;
                nodes.forEach((item) => {
                  item.leaf = item.isLeaf == 1;
                });
                resolve(nodes);
              } else {
                this.$message.error(res.msg);
              }
            });
          }
        },
      },
      rules: {
        serialNumber: [
          { required: true, message: "请填写项目编号", trigger: "blur" },
          {
            min: 1,
            max: 100,
            message: "长度在 1 到 100 个字符",
            trigger: "blur",
          },
        ],
        name: [
          { required: true, message: "请填写项目名称", trigger: "blur" },
          {
            min: 1,
            max: 100,
            message: "长度在 1 到 100 个字符",
            trigger: "blur",
          },
        ],
        generalContractId: [
          { required: true, message: "请选择所属合同", trigger: "change" },
        ],

        projectTypeKey: [
          { required: true, message: "请选择所属项目类型", trigger: "change" },
        ],
        province: [
          { required: true, message: "请选择省份", trigger: "change" },
        ],
        city: [{ required: true, message: "请选择城市", trigger: "change" }],
        area: [{ required: true, message: "请选择区", trigger: "change" }],
        address: [
          { required: true, message: "请填写详细地址", trigger: "change" },
          {
            min: 1,
            max: 100,
            message: "长度在 1 到 100 个字符",
            trigger: "blur",
          },
        ],
        projectInfo: [
          { required: true, message: "请填写项目信息", trigger: "blur" },
        ],
        // startDate: [
        //   { required: true, message: "请选择开工日期", trigger: "blur" },
        // ],
        expectFinishDate: [
          { required: true, message: "请选择预计完工日期", trigger: "blur" },
        ],
        expectFinishCheckDate: [
          {
            required: true,
            message: "请选择预计交工验收日期",
            trigger: "blur",
          },
        ],
        expectAuditDate: [
          { required: true, message: "请选择预计审计日期", trigger: "blur" },
        ],
        defectLiabilityDate: [
          { required: true, message: "请选择缺陷责任期日期", trigger: "blur" },
        ],
        expectCompleteCheckDate: [
          {
            required: true,
            message: "请选择预计竣工验收日期",
            trigger: "blur",
          },
        ],
        applyUserName: [
          { required: true, message: "请填写申请人", trigger: "blur" },
        ],
        applyDeptId: [
          { required: true, message: "请填写申请部门", trigger: "change" },
        ],
      },
    };
  },
  created() {
    this.dialogForm.applyUserName = sessionStorage.getItem("name");
    this.dialogForm.applyDeptId = sessionStorage.getItem("deptId");
    this.dialogForm.applyUserId = sessionStorage.getItem("currentUserId");
    this.getapplyDeptName();
    this.category = "GENERAL_CONTRACT_NAME"; //合同名称
    this.getContractCode(this.category); //获取合同名称下拉框数据
    this.category = "PROJECTTYPE"; //项目类型
    this.getProjectTypeCode(this.category); //获取项目类型下拉框数据
    this.getProjectClubList(0); //获取部门一级下拉列表
  },
  mounted() {
    let ch = document.documentElement.clientHeight - 80;
    document.getElementsByClassName("AddProjectOrder")[0].style.height =
      ch + "px";
    window.onresize = () => {
      return (() => {
        let ch1 = document.documentElement.clientHeight - 80;
        document.getElementsByClassName("AddProjectOrder")[0].style.height =
          ch1 + "px";
      })();
    };
  },
  methods: {
    //获取路由跳转传参
    onActive() {
      this.activeName = "first";
      this.editFlag = this.tabRouteParam ? this.tabRouteParam.editFlag : false;
      if (this.editFlag) {
        //编辑 获取一条项目信息
        this.RouteParam = this.tabRouteParam;
        this.projectId = this.tabRouteParam.id;
        this.getProjectDetail(this.projectId);
      }
      // this.category = "GENERAL_CONTRACT_NAME"; //合同名称
      // this.getContractCode(this.category); //获取合同名称下拉框数据
    },
    //获取部门名称
    getapplyDeptName() {
      //根据用户id去获取组织id
      let reqParam = {
        userId: this.dialogForm.applyUserId,
      };
      getOrgIdService(reqParam).then(
        (res) => {
          if (res.code == 10000000) {
            this.dialogForm.applyDeptName = res.data.deptDisplayName;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          console.log("123");
          this.$alert(err, "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },
    //获取项目部下拉列表数据
    getProjectClubList(deptId) {
      let reqParam = {
        pid: deptId,
        orgId: sessionStorage.getItem("orgId"),
      };
      getDeptListService(reqParam).then(
        (res) => {
          if (res.code == 10000000) {
            // this.total = res.total;
            this.subDeptList = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$alert("系统异常", "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },
    //获取category下拉框数据
    getContractCode(category) {
      let param = {};
      param.category = category;
      getContractCodeByUserCodeService(param)
        .then((res) => {
          if (res.code == 10000000) {
            this.ContractnameList = res.data; //合同名称
            // if(this.param.id){
            //   this.ContractnameList.unshift(this.param)
            // }
            // console.log( this.ContractnameList)
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {});
    },
    //获取一条项目信息
    getProjectDetail() {
      if (this.RouteParam) {
        let param = {};
        param.id = this.projectId;
        getProjectDetailService(param)
          .then((res) => {
            if (res.code == 10000000) {
              this.param.id = res.data.generalContractId;
              this.param.name = res.data.generalContractName;
              if (this.param.id) {
                this.ContractnameList.unshift(this.param);
              }
              this.dialogForm = { ...res.data };
              this.dialogForm.projectItemsDtoList =
                res.data?.projectItemsVOList ?? [];
              this.addressObj = {
                province: res.data.province, //省
                city: res.data.city, //城市
                area: res.data.area, //区
                address: res.data.address,
              };
            } else if (res.code >= 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
            });
          });
      }
    },

    getAddressDetail(AddressDetail) {
      this.dialogForm.province = AddressDetail.province1;
      this.dialogForm.city = AddressDetail.city1;
      this.dialogForm.area = AddressDetail.area1;
      this.dialogForm.address = AddressDetail.address1;
      // this.$set(this.dialogForm,"province",AddressDetail.province1)
    },
    // 提交项目基本信息
    saveProjectInfo(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.approveParams.approveProcessDtoList.length < 1) {
            this.$alert(" 未选择审批人员", "提示", {
              confirmButtonText: "确定",
            });
            return;
          }
          for (
            let i = 0;
            i < this.approveParams.approveProcessDtoList.length;
            i++
          ) {
            delete this.approveParams.approveProcessDtoList[i].type;
            if (
              this.approveParams.approveProcessDtoList[i].approveUserId == "" ||
              null == this.approveParams.approveProcessDtoList[i].approveUserId
            ) {
              this.$alert(
                this.approveParams.approveProcessDtoList[i].jobName +
                  " 节点未选择审批人员",
                "提示",
                {
                  confirmButtonText: "确定",
                }
              );
              return;
            }
          }
          this.$confirm("您确定提交此项目信息, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "info",
          })
            .then(() => {
              this.saveContent();
            })
            .catch(() => {});
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    saveContent() {
      let data = { ...this.dialogForm };
      let param = {};
      // param.currentUserId = 1; // sessionStorage.getItem("userCode");
      // param.currentUserName = "admin";
      param = data;
      if (!this.editFlag) {
        //新增立项单
        saveProjectInfoServices(param)
          .then((res) => {
            if (res.code == 10000000) {
              this.saveApproveFun(res.data);
            } else if (res.code >= 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
            });
          });
      } else {
        //更新立项单
        param.id = this.projectId;
        updateProjectInfoServices(param)
          .then((res) => {
            if (res.code == 10000000) {
              this.saveApproveFun(this.projectId);
            } else if (res.code >= 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
            });
          });
      }
    },
    close() {
      let that = this;
      // this.$router.back();
      if (this.editFlag) {
        this.changTabs("totalReVisitList", "payment-parkfeeRelation");
      } else {
        this.changTabs("find-setting", "payment-parkfeeRelation");
      }
    },
    //获取合同name
    getContractName(val) {
      let obj = {};
      obj = this.ContractnameList.find((item) => {
        return item.id == val; //筛选出匹配数据
      });
      this.dialogForm.generalContractName = obj.name;
      this.getContractDetail(val);
    },
    //获取一条总包合同信息
    getContractDetail(val) {
      if (this.RouteParam) {
        let param = {};
        param.id = val;
        getContractDetailService(param)
          .then((res) => {
            if (res.code == 10000000) {
              let index=this.projectTypeList.findIndex(item=>(item.label== res.data.typeKey))
              if(index==-1){
                this.dialogForm.projectTypeKey = '';
              this.dialogForm.projectTypeName = '';
              }else{
                this.dialogForm.projectTypeKey = res.data.typeKey;
              this.dialogForm.projectTypeName = res.data.typeValue;
              }
             
            } else if (res.code >= 20000000) {
              console.log(res.msg);
            } else {
              console.log(res.msg);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    //数据改变时更新数据
    handleChange(value) {
      let len = value.length;
      this.dialogForm.applyDeptId = value[len - 1];
      //  let labal = this.$refs["cascaderAddr"].currentLabels; //注意2： 获取label值
    },
    //焦点离开时处理label
    handleDeptName(val) {
      if (!val) {
        console.log("1111");
        // let labal = this.$refs["cascaderAddr"].currentLabels; //注意2： 获取label值
        // this.dialogForm.applyDeptName = labal[labal.length - 1];
      }
    },
    //获取项目类型即合同分类下拉框数据
    getProjectTypeCode(category) {
      let param = {};
      param.category = category;
      getBasicDataListService(param)
        .then((res) => {
          if (res.code == 10000000) {
            if (category == "PROJECTTYPE") {
              this.projectTypeList = res.data; //项目类型即总包合同分类
            } else {
              this.contractCodeList = res.data; //总包合同编码
            }
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {});
    },
    //项目类型改变事件
    projecttypechange(val) {
      let obj = {};
      obj = this.projectTypeList.find((item) => {
        return item.label == val; //筛选出匹配数据
      });
      this.dialogForm.projectTypeName = obj.value;
    },
    //存储审批流
    saveApproveLine(selectItems) {
      this.approveParams.approveProcessDtoList = selectItems;
    },
    //创建审批流函数
    async saveApproveFun(projectId) {
      this.approveParams.itemId = projectId;
      this.approveParams.projectId = projectId;
      this.approveParams.approveStatusEnum = "UNDERAPLLY"; //只是先保存，传READY；若审批流直接开始，传UNDERAPLLY
      this.approveParams.approveClass = this.approveClass;
      this.approveParams.itemName = `${this.dialogForm.applyUserName}关于项目 ${this.dialogForm.name} 编号 ${this.dialogForm.serialNumber} 的申请`;
      let res = await saveApproveFun(this.approveParams);
      if (res.code == 10000000) {
        if (!this.editFlag) {
          this.$message.success("保存成功");
          this.changTabs("find-setting", "payment-parkfeeRelation");
        } else {
          this.$message.success("提交成功");
          this.changTabs("totalReVisitList", "payment-parkfeeRelation");
        }
      } else {
        this.$message.error(res.msg);
      }
    },
    //存储附件
    saveUpdateFile(selectItems) {
      this.dialogForm.projectItemsDtoList = selectItems;
    },
    ShowApplyUserDia() {
      this.applyUserDiaVisible = true;
    },
    closeDialog() {
      this.applyUserDiaVisible = false;
    },
    //存储申请人
    saveApplyUser(selectItems) {
      this.dialogForm.applyUserId = selectItems.applyUserId;
      this.dialogForm.applyUserName = selectItems.applyUserName;
      this.dialogForm.applyDeptId = selectItems.applyDeptId;
      this.dialogForm.applyDeptName = selectItems.applyDeptName;
      //  this.$set(this.dialogForm.applyUserName);
      this.applyUserDiaVisible = false;
    },
    //查看立项审批制度
    SeeApproveRule() {
      this.bus.$emit("navMenuChange", {
        routeId: "ApproveRule",
      });
    },
    changTabs(closeTabName, openTableName, params) {
      this.bus.$emit("tabClose", closeTabName);
      this.bus.$emit("navMenuChange", {
        routeId: openTableName,
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";

.AddProjectOrder {
  background-color: white;
  height: 100%;
  overflow: hidden;

  .tabWrap {
    height: calc(100% - 60px);

    // /deep/.el-tabs__item.is-top.is-active {
    //   background-color: #ffffff;
    // }

    /deep/ .el-tabs--top {
      height: 100%;
      overflow: hidden;

      .el-tabs__content {
        height: calc(100% - 80px);
        padding: 20px;
        overflow: auto;

        .el-form-item {
          width: 100%;
        }

        .el-checkbox {
          line-height: 40px;
        }

        .el-textarea {
          min-width: 0px !important;
        }

        .el-form-item__content {
          width: calc(100% - 150px);

          .el-input {
            width: 100%;
          }
        }
      }
    }
  }

  .bottomBtn {
    border-top: 1px solid #e6e6e6;
    width: 60%;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
}

.screenPanel {
  text-align: left;
  height: auto;
}

.approve-rule {
  color: red;
  /* text-align: right; */
  position: absolute;
  right: 30px;
  top: 20px;
  height: 40px;
  display: flex;
  align-items: center;
  z-index: 1;
}

.btnList {
  text-align: center;
  margin-top: 20px;
}

/deep/ .el-header {
  position: relative;
}

/deep/ .el-tabs__item {
  padding: 0 20px !important;
}
.el-select {
  width: 100%;
}
.el-cascader {
  width: 100%;
}

/deep/ .el-tabs__header {
  padding-right: 0px !important;
}
.firstTab {
  width: 70%;
}
@media only screen and(max-width:1680px) {
  .firstTab {
    width: 80%;
  }
}
</style>

<style scoped>
.hidden >>> .el-upload--picture-card {
  display: none;
}
</style>
